<template>
  <div :class="skinClassFun()">
    <div :style="background" class="bgBackground">
    </div>

    <div class="center_cont type1" v-if="loginType == 1">
      <!-- <div> -->
        <div class="logo">
          <img slot="prefix" src="../img/login/YAHAM.png" style="width: 34.08rem; height: 6.97rem;"/>
        </div>
        <div class="login_btn1" @click="login_btn1">
          <span class="text">{{$t('App.text1')}}</span>
        </div>
      <!-- </div> -->
      
    </div>
    <div class="logo_left" v-if="loginType == 2">
      <img slot="prefix" src="../img/login/YAHAM.png" style="width: 23.29rem; height: 4.74rem;"/>
    </div>
    <div class="center_cont type2" v-if="loginType == 2">
      <div class="avatar">
        <img style="width: 11.05rem;height: 11.05rem;" slot="prefix" src="../img/login/login_1.png" />
      </div>
      <div class="input">
        <el-input class="input1"  v-model="username">
          <img slot="prefix" src="../img/login/login_2.png" />
        </el-input>
        <el-input class="input2" show-password  v-model="password">
          <img slot="prefix" src="../img/login/login_3.png" />
        </el-input>
        <div class="text select_lm" :class="languageSelectShow ? 'select' : ''">
          <div class="val_box" @click="languageSelectFun()">
            <div class="val" >{{ language }}</div>
            <div class="icon_x"></div>
          </div>
          <div class="select_xl_lm_bg" v-if="languageSelectShow" @click="languageSelectFun()"></div>
          <div class="select_xl_lm" v-if="languageSelectShow">
            <div class="icon"></div>
            <div class="ul scrollbar_style">
              <div class="li" :class="version == item.id ? 'select' : ''" v-for="(item, index) in versionNavList" :key="index" @click="chagelanguage(item)">
                <span class="text">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- <button class="lang" @click="chagelanguage">
            <span class="text span" >{{ language }}</span>
        </button> -->
        <!-- <el-select class="lang" v-model="version">
          <el-option
            v-for="item in loginList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select> -->
        <!-- <el-select class="lang" v-model="version" @keyup.native="chagelanguage()">
          <el-option key="1" :label="$t('App.login.text9')" value="1"></el-option>
          <el-option key="0" :label="$t('App.login.text10')" value="0"></el-option>
        </el-select> -->
        <div class="flex_box">
          <el-checkbox v-model="checkboxRememberPassword">{{$t('App.login.text8')}}</el-checkbox>
          <span class="btn_span" @click="openPage('retrievePassword')">{{$t('App.login.text7')}}</span>
        </div>
        <div class="btn_box" @click="sureLogin">
          <span>{{$t('App.login.text6')}}</span>
        </div>
      </div>
      
    </div>
    <!-- 提示弹框 -->
    <el-dialog
      title="" :show-close="false"
      :visible.sync="dialogVisible"
      width="36.51rem" class="boot" margin-top="3rem">
      <span class="text" >{{$t('App.text17')}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="login_()">{{$t('App.exit')}}</el-button>
        <el-button @click="confirmSelection()" style="margin-left: 6.18rem;">{{$t('App.ok')}}</el-button>
      </span>
    </el-dialog>

    <!-- 选择页面 -->
    <el-dialog :show-close="false" :visible.sync="selectVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="36.51rem" class="selection" >
      <el-radio-group style="display: grid;" v-model="getUserSettingInfoDateValue_" :disabled="true">
        <el-radio :disabled="getUserSettingInfoDate.sysStatus == 1" label="systemSetting">{{$t('App.status.text0')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.projectStatus == 1" label="projectSettings">{{$t('App.status.text1')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.gatewayStatus == 1" label="gatewayInput">{{$t('App.projectSettings.text5')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.deviceStatus == 1" label="controllerInput">{{$t('App.status.text2')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.groupStatus == 1" label="groupSetting">{{$t('App.status.text3')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.sceneStatus == 1" label="sceneSettingEdit">{{$t('App.status.text4')}}</el-radio>
        <el-radio :disabled="getUserSettingInfoDate.scheduleStatus == 1" label="calendar">{{$t('App.status.text5')}}</el-radio>
      </el-radio-group>
      <span  slot="footer" class="footer">
        <el-button @click="projectSelection()">{{$t('App.ok')}}</el-button>
      </span>
    </el-dialog>

    <div class="bottom_box">
      <p class="bottom_text1"><a href="http://beian.miit.gov.cn" target="view_window">粤ICP备17041404号-15</a></p>
      <div class="text">Version 1.0</div>
    </div>

    <!-- 忘记密码弹窗 -->
    <el-dialog
      :title="$t('App.retrievePassword.text1')"
      :visible.sync="dialogPassword"
      class="password_dialog"
      width="50%">
      <div class="p_top clearfix">
        <p :class="{'w_315':version == '2'}">
          <el-button :class="{'select':passwordType == '1'}" type="text">{{$t('App.mian_sidebar.userNav1')}}</el-button>
          <span>→</span>
          <el-button :class="{'select':passwordType == '2'}" type="text">{{$t('App.mian_sidebar.userNav2')}}</el-button>
        </p>
      </div>


      <el-form ref="formPasswordr" :model="formPasswordr" label-width="150px" v-if="passwordType==='2'">
        <el-form-item :label="$t('App.mian_sidebar.mailbox')+':'" prop="email" :rules="{required: true, message: $t('App.bnwk'), trigger: 'blur'}">
            <el-input v-model="formPasswordr.email" @keyup.native="passwordSaveKeyUp($event)" disabled>
                <i slot="prefix" class="el-input__icon el-icon-message"></i>
            </el-input>
        </el-form-item>

        <el-form-item class="getVerificatioCode" :label="$t('App.mian_sidebar.verificationCode')+':'" prop="code" :rules="{required: true, message: $t('App.bnwk'), trigger: 'blur'}">
            <el-input class="input_button" v-model="formPasswordr.code" @keyup.native="passwordSaveKeyUp($event)">
                <i slot="prefix" class="el-input__icon el-icon-edit-outline"></i>
            </el-input>
            <el-button style="margin-left:10px;" @click="userGetCode()" :disabled="userGetCodeButton != $t('App.getVerificatioCode')">{{userGetCodeButton}}</el-button>
        </el-form-item>

        <el-form-item :label="$t('App.mian_sidebar.newPassword')+':'" prop="surePwd" :rules="{required: true, message: $t('App.bnwk'), trigger: 'blur'}">
            <el-input type="password" v-model="formPasswordr.surePwd" @keyup.native="passwordSaveKeyUp($event)">
                <i slot="prefix" class="el-input__icon el-icon-goods"></i>
            </el-input>
        </el-form-item>
        <el-form-item :label="$t('App.mian_sidebar.confirmPassword')+':'" prop="newPwd" :rules="{required: true, message: $t('App.bnwk'), trigger: 'blur'}">
            <el-input type="password" v-model="formPasswordr.newPwd" @keyup.native="passwordSaveKeyUp($event)">
                <i slot="prefix" class="el-input__icon el-icon-goods"></i>
            </el-input>
        </el-form-item>
      </el-form>

      <el-form ref="formUserName" :model="formUserName" label-width="150px" v-if="passwordType==='1'">
        <el-form-item :label="$t('App.mian_sidebar.accountName')" prop="name" :rules="{required: true, message: $t('App.bnwk'), trigger: 'blur'}">
            <el-input  v-model="formUserName.name" @keyup.native="passwordSaveKeyUp($event)">
              <!-- <i slot="prefix" class="el-input__icon icon-user iconfont"></i> -->
              <!-- <img slot="prefix" src="../img/login/login_2.png" /> -->
            </el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="userGetUser()" v-if="passwordType==='1'">{{$t('App.nextStep')}}</el-button>
        <el-button @click="lastStep()" v-if="passwordType==='2'">{{$t('App.lastStep')}}</el-button>
        <el-button type="primary" @click="passwordSave()" v-if="passwordType==='2'">{{$t('App.save')}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script type="text/javascript">
  import allUrl from '../api/allUrl.js'
  import base from '../api/base.js'
  import jqueryK from '../api/jqueryK.js'
  import { mapGetters } from 'vuex'
  export default {
    name: 'login',
    data () {
      return {
        languageSelectShow: false,
        versionNavList:[
          {id:0,name:'English'},
          {id:1,name:'中文'},
          {id:2,name:'日本語'},
        ],

        passwordType:'1',
        formUserName:{
          name:'',
        },
        formPasswordr:{
          email:'',
          code:'',
          surePwd:'',
          newPwd:'',
        },
        dialogPassword:false,

        loginType: 1,
        username: '',
        password: '',
        code: '',
        checkboxRememberPassword: false,
        codeImage: '',
        loginList:[],
        language: 'English',
        background: {
          backgroundImage: 'url(' + require('../../src/img/login/background_1.png') + ')',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundColor: '#000',
          backgroundPosition: 'center top'
        },

        dialogVisible: false,
        selectVisible: false,
        // radio: '1',

        provinceNavList: [],
        provinceNav:'',

        name:'',
        id:'',

        getUserSettingInfoDateValue_:'systemSetting',
        
        getUserSettingInfoDate :{
          sysStatus:'',
          projectStatus:'',
          gatewayStatus:'',
          deviceStatus:'',
          groupStatus:'',
          sceneStatus:'',
          scheduleStatus:'',
        },

        isLogin_1: true,

        userGetCodeButton:'',
      }
    },
    computed: {
      ...mapGetters({ 
        theme: 'theme', 
        version: 'version',
        token:'token', 
        routerStr: 'routerStr', 
        remRatio: 'remRatio', 
        domainName: 'domainName',
        client_key:'client_key',
      }),
    },
    mounted () {
      this.userGetCodeButton = this.$t('App.getVerificatioCode');

      var storage = window.localStorage;
      console.log(this.username,this.password,'-9-9-99')
      
      // storage.setItem('userData', '');
      storage.setItem('projectId', '');
      if (storage.getItem("rememberPassword")) {
        this.checkboxRememberPassword = true;
        this.username = storage.getItem('udfn');
        this.password = jqueryK.base64Decode(storage.getItem('udfp'));
        storage.getItem('udfp', jqueryK.base64Decode(this.password));
      } 
      // else {
      //   this.checkboxRememberPassword = false;
      //   storage.removeItem('userData');
      //   storage.removeItem('projectId');   
      // }
      console.log(this.checkboxRememberPassword,'--4646--')
      this.$store.commit('SIDEBARSHOW', {
        sideBarShow: false,
      })
      console.log(this.loginList,'--8---8--8999')
      // this.getCodeImage();
      console.log(this.version)
      this.versionFun(this.version)
    },
    methods: {
      
      skinClassFun(){
        let obj = {};
        // 'login ' + (version == 1?'cn ':'') + theme
        obj['login'] = true;
        obj['cn'] = this.version == '1';
        obj['en'] = this.version == '0';
        obj['ja'] = this.version == '2';
        obj[this.theme] = true;
        return obj
      },
      languageSelectFun() {
          if (this.languageSelectShow) {
            this.languageSelectShow =  false
          } else {
            this.languageSelectShow =  true
          }
      },
      // handleClose(done) {
      //   this.$confirm('确认关闭？')
      //     .then(_ => {
      //       done();
      //     })
      //     .catch(_ => {});
      // },
      openPage(){
        this.passwordType = '1';
        this.formUserName.name = '';
        for(let key in this.formPasswordr){
          this.formPasswordr[key] = '';
        }
        this.dialogPassword = true;
      },
      passwordSaveKeyUp(e){
        if(e.key == 'Enter'){
          this.passwordSave();
        }
      },
      passwordSave(){
        base.ajax_post(
          allUrl.user.user_changePwd,
          {
            version: this.version,
            username:this.formUserName.name,
            code:this.formPasswordr.code,
            surePwd:this.formPasswordr.surePwd,
            pwd:this.formPasswordr.newPwd,
          },
          {},
          data =>{
            console.log(data,'---11-222-')
            // this.formPasswordr.email = data.data.email;

              this.dialogPassword = false;
              this.$message({
                showClose: true,
                message: data.msg,
                type: 'success'
              });
              var storage = window.localStorage;
              storage.setItem('userData','');
              this.$store.commit('pageTypeFun',{
                  pageType:'login',
              })
              // console.log(data)
          },
        this)
      },
      lastStep() {
        this.passwordType = '1';
      },
      //获取邮箱
      userGetUser() {
        base.ajax_post(
            allUrl.user.user_getUserEmail,
            {
              username:this.formUserName.name,
              // email:this.formPasswordr.email,
              version:this.version,
            },
            {},
            data =>{
              console.log(data,'99--11')
              this.passwordType = '2';
              this.formPasswordr.email = data.data.email

            },
        this)
      },
      //获取验证码
      userGetCode(){
        let this_ = this;
        this.userGetCodeButton = 30;
        let time = setInterval(function(){
            this_.userGetCodeButton --;
            if(this_.userGetCodeButton == '0'){
                clearInterval(time)
                this_.userGetCodeButton = this_.$t('App.getVerificatioCode');
                // if(this_.version === '1'){
                //   this_.userGetCodeButton = 'Get verification code';
                // }else if(val === '0'){
                //   this_.userGetCodeButton = '获取验证码';
                // }else if(this.version === '2'){
                //   this.userGetCodeButton = 'получить код проверки подлинности';
                // }
            }
        },1000)
        base.ajax_post(
            allUrl.user.user_getEmailCode,
            {
              username:this.formUserName.name,
              // email:this.formPasswordr.email,
              version:this.version,
            },
            {},
            data =>{
              console.log(data,'99--22')
              
            },
        this)
      },
      projectSelection(){
        // console.log(this.getUserSettingInfoDateValue,'-99999999-1111')
        
        let storage = window.localStorage;
        this.projectNavList(data=>{
          console.log(data.data, '--24-')
          this.provinceNavList = data.data;
          
          let projectName = '';
          for(let d of this.provinceNavList){
            if(d.id == this.provinceNav){
              projectName = d.name
            }
          }
          this.$store.commit('projectSelectFun', {
            projectId: this.provinceNav,
            projectName: projectName,
          })
          let projectObj = {
            name: projectName,
            id: this.provinceNav,
          }
          this.$store.commit("getUserSettingInfoSelectFun", {
            getUserSettingInfoDateValue: this.getUserSettingInfoDateValue_,
          });
          storage.setItem('projectObj', JSON.stringify(projectObj))
          this.$router.push({ path: '/home' })
          this.$store.commit('ROUTERSTRFUN', {
            routerStr: '/home',
          })
        });
        // this.selectVisible = false;
        // let projectName = '';
        // for(let d of this.provinceNavList){
        //   if(d.id == this.provinceNav){
        //     projectName = d.name
        //   }
        // }
        // this.$store.commit('projectSelectFun', {
        //   projectId: this.provinceNav,
        //   projectName: projectName,
        // })
        // let projectObj = {
        //   name: projectName,
        //   id: this.provinceNav,
        // }
        // var storage = window.localStorage;
        // storage.setItem('projectObj', JSON.stringify(projectObj))

        // // for(let d of this.provinceNavList){
        // //   if(d.value == id){
        // //     this.provinceNavList.name = d.text;
        // //   }
        // // }
        // // wx.setStorageSync("projectId",id);

        // // this.provinceNav = id;
        
        // this.$router.push({ path: '/home' })
        // this.$store.commit('ROUTERSTRFUN', {
        //   routerStr: '/home',
        // })
      },
      login_(){
        let storage = window.localStorage;
        this.projectNavList(data=>{
          console.log(data.data, '--24-')
          this.provinceNavList = data.data;
          
          let projectName = '';
          for(let d of this.provinceNavList){
            if(d.id == this.provinceNav){
              projectName = d.name
            }
          }
          this.$store.commit('projectSelectFun', {
            projectId: this.provinceNav,
            projectName: projectName,
          })
          let projectObj = {
            name: projectName,
            id: this.provinceNav,
          }
          storage.setItem('projectObj', JSON.stringify(projectObj))
          this.$router.push({ path: '/home' })
          this.$store.commit('ROUTERSTRFUN', {
            routerStr: '/home',
          })
        });
      },
      confirmSelection() {
        this.selectVisible = true;
      },
      login() {
        // console.log(this.isLogin_1,'-99696---')
        // if(this.isLogin_1){
        //   this.sureLogin()
        //   // return
        // } 
        let storage = window.localStorage;
        let time = new Date();
        var client_key = navigator.userAgent +time;
        base.ajax_post(
          allUrl.login.login,
          // allUrl.login.sureLogin,
          {
            username: this.username,
            password: this.password,
            version: this.version,
            // code: this.code,
            clientKey: client_key,
          },
          {},
          data => {
            console.log(data,'-88888')
            this.$message({
              showClose: true,
              message: this.$t('App.message.text53'),
              type: 'success'
            });
            this.loginList = data.data;
            let obj = {
              username: this.username,
              id: data.data.id,
              role: data.data.type,
              // lastLoginTime: data.data.lastLoginTime,
              clientKey: data.data.clientKey,
              token: data.data.token,
              // number: data.data.number,
              avatar: data.data.avatar,
              version: this.version,
            }
            this.$store.commit('USERDATAFUN', obj)
            storage.setItem('userData', JSON.stringify(obj))

            if (this.checkboxRememberPassword) {
              storage.setItem('rememberPassword', 'true');
              storage.setItem('udfn', this.username);
              storage.setItem('udfp', jqueryK.base64Encode(this.password));
            } else {
              storage.setItem('rememberPassword', 'false');
              storage.setItem('udfn', '');
              storage.setItem('udfp', '');
              // localStorage.clear()
              // window.sessionStorage.clear()
            }

            this.$store.commit('HEADERIDFUN', {
              headerUpdate: this.headerUpdate + 1,
            })
            if (this.version == '1') {
              this.loadJS('https://webapi.amap.com/maps?v=1.4.15&key=6f0388812f958e88699f2ea6fede068b&plugin=AMap.MarkerClusterer,AMap.ToolBar,AMap.Autocomplete,AMap.PlaceSearch,AMap.Geocoder,AMap.DistrictSearch,AMap.DistrictLayer,AMap.MassMarks', ()=> {
                this.loadJS('https://a.amap.com/jsapi_demos/static/china.js', function () { })
                this.loadJS('https://webapi.amap.com/ui/1.0/main.js?v=1.0.11', function () { })
                this.loadJS('https://webapi.amap.com/loca?v=1.3.2&key=6f0388812f958e88699f2ea6fede068b', function () { })
              })
            } 
            if(this.version == '0'){
              if (!this.isGoogleapis) {
                this.isGoogleapis = true;
                this.loadJS('https://maps.googleapis.com/maps/api/js?key=AIzaSyBu9LweyAtYu26iTWwzxozPEco1xosnIoI&language=en&libraries=places', () => {
                    this.loadJS('./js/infobox.js', function () { })
                    this.loadJS('./js/richmarker.js', function () { })
                })
              }
            }
            
            base.websocket(allUrl.websocket.ws, websocket => {
              // this.websocket_new_em_register = websocket;
              console.log(websocket,'------9')
              // this.websocket.send('{"topic":"new_em_register","username":"' + (data.username + '') + '"}');
              websocket.send(JSON.stringify({'topic':'/user/login','token':(this.token)}));
              websocket.onmessage = event => {
                let data = JSON.parse(event.data);
                console.log(data)

                if (data.topic == "/user/logout") {
                  console.log(data.token,'--969699----9')
                  this.$confirm(this.$t('App.message.text51'), this.$t('App.message.text4'), {
                      confirmButtonText: this.$t('App.message.text2'),
                  })
                  
                  this.signOut();
                  websocket.close()
                }
              }
            }, this)

            // base.websocket_sure((res, websocketL) => {
            //   this_.$store.commit('websocketFun', {
            //     websocket: websocketL,
            //   })
            //   console.log('-----------',res)
            //   if (res.code == '0000' && res.data.status == 1) {//websocket连接成功后，开始调度

            //     // baseApi.ajax_post1(
            //     // 	allUrl.login.register_login,
            //     // 	{
            //     // 		username: data.data.username,
            //     // 		client_key: data.data.client_key,
            //     // 		version: data.data.version,
            //     // 		clientid: res.data.clientid,
            //     // 	},
            //     // 	this_
            //     // )
            //     console.log('---456456-------')
            //     websocketL.send('{"type":"heartbeat","userid":"' + this_.userId + '"}')
            //     // let time = setInterval(() => {
            //     // 	websocketL.send('{"type":"heartbeat","userid":"' + this_.userId + '"}')
            //     // }, 30000)
            //   } else if (res.code != '0000' && res.status == 2) {//调度成功
            //     this_.signOut();
            //     this_.$message({
            //       showClose: true,
            //       message: res.msg,
            //       type: 'warning'
            //     });
            //     websocketL.close();
            //   } else {//调度失败
            //   }
            // })

            console.log(this.version,'--1--5--9')
            this.getUserSettingInfo(data => {
              if (data.isTrue&&obj.role!=2) {
                this.dialogVisible = true;
              }else{
                this.projectNavList(data=>{
                  console.log(data.data, '--24-')
                  this.provinceNavList = data.data;
                  
                  let projectName = '';
                  for(let d of this.provinceNavList){
                    if(d.id == this.provinceNav){
                      projectName = d.name
                    }
                  }
                  this.$store.commit('projectSelectFun', {
                    projectId: this.provinceNav,
                    projectName: projectName,
                  })
                  let projectObj = {
                    name: projectName,
                    id: this.provinceNav,
                  }
                  storage.setItem('projectObj', JSON.stringify(projectObj))
                  this.$router.push({ path: '/home' })
                  this.$store.commit('ROUTERSTRFUN', {
                    routerStr: '/home',
                  })
                });
              }
            });
          },
          this,()=>{
            this.$alert('----', this.$t('App.message.text1'), {
                confirmButtonText: this.$t('App.message.text2'),
            });
          }
        )
      
      },
      // 
      sureLogin() {
        console.log(this.isLogin_1,'-99696---')
        let storage = window.localStorage;
        let time = new Date();
        var client_key = navigator.userAgent +time;
        base.ajax_post(
          allUrl.login.sureLogin,
          {
            username: this.username,
            password: this.password,
            version: this.version,
            // code: this.code,
            clientKey: client_key,
          },
          {},
          data => {
            console.log(data)
            
            if(data.code == '10014'){
              this.$confirm(this.$t('App.message.text50'), this.$t('App.message.text1'), {
                confirmButtonText: this.$t('App.message.text2'),
                cancelButtonText: this.$t('App.message.text6'),
                type: 'warning'
              }).then(() => {
                this.isLogin_1 = false;
                this.login();
                console.log(this.isLogin_1,'-6---')
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: this.$t('App.message.text49')
                });          
              });
            } else {
              console.log(data,'-88888')
              this.$message({
                showClose: true,
                message: this.$t('App.message.text53'),
                type: 'success'
              });
              this.loginList = data.data;
              let obj = {
                username: this.username,
                id: data.data.id,
                role: data.data.type,
                // lastLoginTime: data.data.lastLoginTime,
                clientKey: data.data.clientKey,
                token: data.data.token,
                // number: data.data.number,
                avatar: data.data.avatar,
                version: this.version,
              }
              this.$store.commit('USERDATAFUN', obj)
              storage.setItem('userData', JSON.stringify(obj))

              if (this.checkboxRememberPassword) {
                storage.setItem('rememberPassword', 'true');
                storage.setItem('udfn', this.username);
                storage.setItem('udfp', jqueryK.base64Encode(this.password));
              } else {
                storage.setItem('rememberPassword', 'false');
                storage.setItem('udfn', '');
                storage.setItem('udfp', '');
                // localStorage.clear()
                // window.sessionStorage.clear()
              }

              this.$store.commit('HEADERIDFUN', {
                headerUpdate: this.headerUpdate + 1,
              })
              if (this.version == '1') {
                this.loadJS('https://webapi.amap.com/maps?v=1.4.15&key=6f0388812f958e88699f2ea6fede068b&plugin=AMap.MarkerClusterer,AMap.ToolBar,AMap.Autocomplete,AMap.PlaceSearch,AMap.Geocoder,AMap.DistrictSearch,AMap.DistrictLayer,AMap.MassMarks', ()=> {
                  this.loadJS('https://a.amap.com/jsapi_demos/static/china.js', function () { })
                  this.loadJS('https://webapi.amap.com/ui/1.0/main.js?v=1.0.11', function () { })
                  this.loadJS('https://webapi.amap.com/loca?v=1.3.2&key=6f0388812f958e88699f2ea6fede068b', function () { })
                })
              } 
              if(this.version == '0'){
                if (!this.isGoogleapis) {
                  this.isGoogleapis = true;
                  this.loadJS('https://maps.googleapis.com/maps/api/js?key=AIzaSyBu9LweyAtYu26iTWwzxozPEco1xosnIoI&language=en&libraries=places', () => {
                      this.loadJS('./js/infobox.js', function () { })
                      this.loadJS('./js/richmarker.js', function () { })
                  })
                }
              }
              // console.log('--969699----9')
              // base.websocket(allUrl.websocket.ws, websocket => {
              //   // this.websocket_new_em_register = websocket;
              //   console.log(websocket,'------9')
              //   // this.websocket.send('{"topic":"new_em_register","username":"' + (data.username + '') + '"}');
              //   // websocket.send(JSON.stringify('{"/user/'+(this.token)+'/forceLogout"}'));
              //   websocket.send(JSON.stringify({'topic':'/user/login','token':(this.token)}));
              //   websocket.onmessage = event => {
              //     let data = JSON.parse(event.data);
              //     console.log(data)
              //   }
              // }, this)
              console.log(this.version,'--1--5--9')
              this.getUserSettingInfo(data => {
                if (data.isTrue&&obj.role!=2) {
                  this.dialogVisible = true;
                }else{
                  this.projectNavList(data=>{
                    console.log(data.data, '--24-')
                    this.provinceNavList = data.data;
                    
                    let projectName = '';
                    for(let d of this.provinceNavList){
                      if(d.id == this.provinceNav){
                        projectName = d.name
                      }
                    }
                    this.$store.commit('projectSelectFun', {
                      projectId: this.provinceNav,
                      projectName: projectName,
                    })
                    let projectObj = {
                      name: projectName,
                      id: this.provinceNav,
                    }
                    storage.setItem('projectObj', JSON.stringify(projectObj))
                    this.$router.push({ path: '/home' })
                    this.$store.commit('ROUTERSTRFUN', {
                      routerStr: '/home',
                    })
                  });
                }
              });
            }
            
            // this.sureLoginList = data.data;
          },
          this,()=>{
            // console.log('-55555')
            // this.$alert('----', this.$t('App.message.text1'), {
            //     confirmButtonText: this.$t('App.message.text2'),
            //     callback: () => {
            //       console.log(this,'--dd-dd-d-d----')
            //     }
            // });
            
          }
        )
      },
      //退出登录
      signOut(){
        // this.$confirm(this.$t('App.message.text41'), this.$t('App.message.text4'), {
        //   confirmButtonText: this.$t('App.message.text5'),
        //   cancelButtonText: this.$t('App.message.text6'),
        //   type: 'warning'
        // }).then(() => {
          base.ajax_post(
          allUrl.login.logout,
          {
            username: this.username,
            clientType: this.os,
            token: this.token,
            version: this.version,
          },
          {},
          (data) => {
            this.$message({
              showClose: true,
              message: data.msg,
              type: "success",
            });
            this.pageType = "";
            this.pageTitle = "";
          
            // localStorage.clear()
            // window.sessionStorage.clear()
            this.$router.push('/login')
          },
          this)
      },
      // openPage (val) {
      //   window.open('#/' + val);
      // },
      
      openWeb (val) {
        window.open(val);
      },
      login_btn1(){
        // if (this.loginType == 1) {
        //   this.loginType== 2 ,
        // }
        this.loginType = 2;
      },
      chagelanguage(data){
        // console.log(this.$i18n.locale)
        // this.$i18n.locale == 'zh-CN' ? this.$i18n.locale = 'en-US' : this.$i18n.locale = 'zh-CN'   //设置中英文模式
        // console.log(this.$i18n.locale)
        let version = data.id;
        this.versionFun(version)
      },
      versionFun(val){
          this.$store.commit('VERSION',{
              version:val,
          })
          // let this_ = this;
          if(val == '1'){
              this.$i18n.locale = 'zh-CN'
              this.language = "中文"

              // if(!this.webapiAmap){
              //     this.loadJS('https://webapi.amap.com/maps?v=1.4.6&key=192cfd61cc0fbe8c2cf8d5c314f43bb3&plugin=AMap.MarkerClusterer,AMap.ToolBar,AMap.Autocomplete,AMap.PlaceSearch,AMap.Geocoder,AMap.Geolocation',function(){
              //         this_.loadJS('https://webapi.amap.com/ui/1.0/main.js?v=1.0.11',function(){})
              //         this_.$store.commit('WEBAPIAMAP',{
              //             webapiAmap:true
              //         })
              //     })
              // }
          }
          if(val == '0'){
              this.$i18n.locale = 'en-US'
              this.language = "English"
            // if(!this.isGoogleapis){
            //   this.loadJS('https://maps.googleapis.com/maps/api/js?key=AIzaSyBu9LweyAtYu26iTWwzxozPEco1xosnIoI&language=en',function(){
            //       this_.loadJS('./js/infobox.js',function(){
            //           this_.loadJS('./js/richmarker.js',function(){
            //               this_.$store.commit('ISGOOGLEAPIS',{
            //                   isGoogleapis:true
            //               })
            //           })
            //       })
            //   })
            // }
          }
          if(val == '2'){
              this.$i18n.locale = 'ja'
              this.language = "日本語"
            // if(!this.isGoogleapis){
            //   this.loadJS('https://maps.googleapis.com/maps/api/js?key=AIzaSyBu9LweyAtYu26iTWwzxozPEco1xosnIoI&language=en',function(){
            //       this_.loadJS('./js/infobox.js',function(){
            //           this_.loadJS('./js/richmarker.js',function(){
            //               this_.$store.commit('ISGOOGLEAPIS',{
            //                   isGoogleapis:true
            //               })
            //           })
            //       })
            //   })
            // }
          }
      },
      loadJS( url, callback ){
          let script = document.createElement('script'),
          fn = callback || function(){};
          script.type = 'text/javascript';
          //IE
          if(script.readyState){
            script.onreadystatechange = function(){
              if( script.readyState == 'loaded' || script.readyState == 'complete' ){
                script.onreadystatechange = null;
                fn();
              }
            };
          }else{
            //其他浏览器
            script.onload = function(){
              fn();
            };
          }
          script.src = url;
          document.getElementsByTagName('head')[0].appendChild(script);
      },
      //获取用户设置状态信息
      getUserSettingInfo(callback) {
        base.ajax_post(
          allUrl.user.user_getUserSettingInfo,
          {
          username: this.username,
          version: this.version,
          token:this.token,
          },
          {},
          data => {
            this.getUserSettingInfoDate = data.data;
            data.isTrue = false;
            if(this.getUserSettingInfoDate.sysStatus == 0){
              this.getUserSettingInfoDateValue_ = 'systemSetting'
              data.isTrue = true
            } else if(this.getUserSettingInfoDate.projectStatus == 0){
              this.getUserSettingInfoDateValue_ = 'projectSettings'
              data.isTrue = true
            }else if(this.getUserSettingInfoDate.gatewayStatus == 0){
              this.getUserSettingInfoDateValue_ = 'gatewayInput'
              data.isTrue = true
            } else if(this.getUserSettingInfoDate.deviceStatus == 0){
              this.getUserSettingInfoDateValue_ = 'controllerInput'
              data.isTrue = true
            } else if(this.getUserSettingInfoDate.groupStatus == 0){
              this.getUserSettingInfoDateValue_ = 'groupSetting'
              data.isTrue = true
            } else if(this.getUserSettingInfoDate.sceneStatus == 0){
              this.getUserSettingInfoDateValue_ = 'sceneSettingEdit'
              data.isTrue = true
            }else if(this.getUserSettingInfoDate.scheduleStatus == 0){
              this.getUserSettingInfoDateValue_ = 'schedule'
              data.isTrue = true
            }
            if(callback){
              callback(data)
            }
          },
          this
        )
      },
      projectNavList(callback) {
        base.ajax_post(
          allUrl.project.project_nav,
          {
            username: this.username,
            version: this.version,

            token:this.token,
            // clientType:this.os,
          },
          {},
          data => {
            callback(data)
            // console.log(this.provinceNavList,this.provinceNavList[0].id,'--27-')

          },
          this
        )
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.login {
  width: 100%;
  height: 100%;
  min-height: 56rem;
  // min-width: 120rem;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  display: flex;
  // background-image: url("../img/login_bg.jpg");
  background-size: 100% 100%;
  background-position: center;
  
  .select_lm {
    margin-left: 0.5rem;
    position: relative;
    width: 31.44rem;
    margin: 1.12rem 0 0 3.68rem;
    &.noSelect{
      .val_box{
        background:rgba(128,128,128,0.5);
        cursor: no-drop;
      }
    }
    &.multiple {
      .li {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .selectDrop {
        margin-left: 1rem;
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
        border: 0.15rem solid #00c6ff;
        display: flex;
        align-items: center;
        justify-content: center;
        visibility: hidden;

        &.select {
          visibility: initial;
        }

        .drop {
          width: 0.55rem;
          height: 0.55rem;
          background: #00c6ff;
          border-radius: 50%;
        }
      }
    }

    &.select {
      .val_box {
        .icon_x {
          transform: rotateZ(90deg);
        }
      }
    }

    .val_box {
      height: 3.8rem;
      line-height: 3.8rem;
      border-radius: 0.2rem;
      // border: 0.1rem solid #3a636f;
      padding-left: 0.5rem;
      padding-right: 1.2rem;
      cursor: pointer;
      display: flex;
      // align-items: center;
      justify-content: center;
      background-color: #EDF4F5FF;
      width: 31.44rem;
      border-radius: 0.33rem;
      border: 1px solid #3A636F;

      .i {
        top: 0.3rem;
        left: -1.5rem;
        position: absolute;
        margin-right: 0.5rem;
        color: #ff0101;
      }

      .val {
        font-family: Calibri;
        font-weight: normal;
        font-size: 1.8rem;
        color: #3a636f;
        margin-right: 0.5rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .icon_x {
        // transition: all 0.5s;
        position: absolute;
        top: 1.2rem;
        right: 1rem;
        width: 1.6rem;
        height: 1.6rem;
        transform: rotateZ(90deg);
        background-image: url("../img/icon/rightArrow.png");
        background-position: center;
        background-size: 100% 100%;
      }
    }

    .select_xl_lm_bg {
      position: fixed;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      z-index: 1;
    }

    .select_xl_lm {
      position: absolute;
      right: 0;
      top: 3.9rem;
      width: 31.44rem;
      // width: 14rem;
      // height: 12rem;
      border: 0.1rem solid #3a636f;
      border-radius: 0.5rem;
      z-index: 1002;
      background: #f4fbfd;

      .ul {
        background: #f4fbfd;
        border-radius: 1rem;
        position: relative;
        z-index: 1;
        max-height: 20rem;
        margin: 0 0.5rem;
      }

      // .icon {
      //   position: absolute;
      //   right: 1.2rem;
      //   top: -0.5rem;
      //   width: 1rem;
      //   height: 1rem;
      //   background: #f4fbfd;
      //   border-top: 0.1rem solid #3a636f;
      //   border-left: 0.1rem solid #3a636f;
      //   // border-radius: 0.1rem;
      //   transform: rotateZ(45deg);
      // }

      .li {
        padding-left: 1.25rem;
        padding-right: 1rem;
        height: 2.5rem;
        line-height: 2.5rem;
        font-family: Calibri;
        font-weight: normal;
        font-size: 1.8rem;
        color: #3a636f;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        &.select{
          background: #e3f9ff;
        }
        .edit {
          margin-left: 1rem;
          visibility: hidden;
          display: inline-block;
          width: 1.5rem;
          height: 1.5rem;
          background-image: url("../img/icon/edit.png");
          background-size: 100%;
          background-position: center;
        }
        &:hover {
          background: #e3f9ff;
          .edit {
            visibility: initial;
          }
        }
        .text {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }

  &.cn {
    // background-image: url("../img/login_bg_v1.png");
  }
  &.ja {
    .boot .el-dialog__footer .el-button{
      width: initial;
      padding: 0 0.5rem;
    }
  }
  .bgBackground{
    width:100%;
    height:100%;
  }
  .logo_left {
    position: absolute;
    left: 0;
    top: 0;
    margin-left: 3.19rem;
    margin-top: 2.3rem;
  }
  .type1 {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -15rem;
    margin-top: -13rem;
  }
  .type2 {
    position: absolute;
    left: calc(50% - 19rem);
    width: 38rem;
    top: 50%;
    // margin-left: -19.5rem;
    margin-top: -25rem;
  }
  .center_cont{
    
    // position: absolute;
    // left: 50%;
    // top: 50%;
    // margin-left: -15rem;
    // margin-top: -13rem;
    
    .el-input {
      // width: 31.67rem;
      // height: 4.12rem;
      // width: 32.54rem;
      height: 4.12rem;
      border: 0px solid #53636D;
      border-radius: 0.44rem;
      .el-input__inner {
        height: 3.8rem;
        line-height: 3.8rem;
        // height: 4.12rem;
        padding-left: 4rem;
        font-size: 1.46rem;
        background-color: #EDF4F5FF;
        
      }
      img {
        margin: 0.72rem;
        width: 2.24rem;
        // height: 2.24rem;
        // height: 1rem;
        // justify-content: center;
        // display: flex;
        // align-items: center;
      }
    }
    // loginType = 1
    .login_btn1 {
      margin: 6.05rem 0 0 10.59rem;
      // margin-top: 6.05rem;
      width: 12.89rem;
      height: 3.88rem;
      text-align: center;
      cursor: pointer;
      background: #00C6FF;
      border-radius: 0.33rem;
      opacity: 0.5;
      span {
        font-family: Calibri;
        font-weight: normal;
        font-size: 1.8rem;
        color: #FFFFFF;
        line-height: 3.88rem;
      }
    }
    // loginType = 2
    .avatar {
      // margin:0 0 3.42rem 12.63rem;
      // margin-left: 12rem;
      justify-content: center;
      display: flex;
      margin-bottom: 3.88rem;
      .img {
        width: 11.05rem;
        height: 11.05rem;
      }
    }
    .input {
      // width: 39.75rem;
      // height: 28.05rem;
      // background: #FFFFFF;
      // opacity: 0.5;
      // border-radius: 0.88rem;
      
      width: 100%;
      height: 27rem;
      background: #EDF4F5;
      border-radius: 0.53rem;
      border: 1px solid #3A636F;
      opacity: 0.9;
    }
    .input1 {
      margin: 2.04rem 0 0 3.68rem;
      
      width: 31.44rem;
      height: 4rem;
      border-radius: 0.33rem;
      border: 1px solid #3A636F;
      .el-input__inner {
        height: 3.8rem;
        border: 0 solid #3A636F;
      }
    }
    .input2 {
      width: 31.44rem;
      height: 4rem;
      margin: 0.99rem 0 0 3.68rem;
      border-radius: 0.33rem;
      border: 1px solid #3A636F;
      .el-input__icon {
        line-height: 3.98rem;
      }
      .el-input__inner {
        height: 3.8rem;
        border: 0 solid #3A636F;
      }
    }
    .input3_box {
      margin: 1.67rem 0 0 3.77rem;
      display: flex;
      .input3 {
        width: 20.5rem;
      }
      .img_box {
        background: #f2f2f2;
        // border: 1px solid #DDDDDD;
        border-radius: 2px;
        overflow: hidden;
        margin-left: 0.83rem;
        width: 10.33rem;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .lang {
      margin: 1.12rem 0 0 3.68rem;
      background-color: #EDF4F5FF;
      width: 31.44rem;
      height: 3.98rem;
      border-radius: 0.33rem;
      border: 1px solid #3A636F;
      .span {
        font-size: 1.8rem;
        font-family: Calibri;
        font-weight: normal;
        color: #3A636F;

      }

    }
    .btn_box {
      margin: 0 0 0.83rem 3.68rem;
      width: 31.44rem;
      height: 3.98rem;
      line-height: 3.33rem;
      text-align: center;
      // background: #ffffff;
      background-color: #EDF4F5FF;

      border: 1px solid #000000;
      border-radius: 2px;
      cursor: pointer;
      span {
        letter-spacing: 0;
        text-align: center;

        font-family: Calibri;
        font-weight: normal;
        font-size: 1.8rem;
        color: #3A636F;
        line-height: 4.24rem;
      }
    }
    .flex_box {
      margin-top: 1rem;
      margin-left: 3.62rem;
      width: 31.44rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-checkbox {
        color: #3A636F;
      }
      .el-checkbox__label{
        // color: #000000;
        color: #3A636F;
        font-family: Calibri;
        // line-height: 4.39rem;
        line-height: 4.24rem;
        // font-weight: normal;
        font-weight: 400;
        font-size: 1.64rem;
      }
      .el-checkbox__input.is-checked + .el-checkbox__label {
        font-family: Calibri;
        font-weight: 400;
        font-size: 1.64rem;
        color: #3A636F;
        line-height: 4.24rem;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #05cfab;
        border-color: #05cfab;
      }
      .btn_span {

        font-family: Calibri;
        font-weight: normal;
        font-size: 1.41rem;
        color: #3A636F;
        cursor: pointer;
      }
    }
  }
  
  .bottom_box{
    
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 4.87rem;
    background: rgba(182, 194, 200, 1);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    
    .bottom_text1{
      // margin-bottom: 10px;
      // margin: auto;
      position: absolute;
      width: 30rem;
      left: calc(50% - 15rem);
      top: 1.5rem;
      text-align:center;
      font-family: Calibri;
      color: rgba(255, 255, 255, 0.6);
      font-size: 1.5rem;
      a {
        color: #fff;
      }

      span {
        color: #fff;
      }
    }
    .text {
      // font-family: Segoe UI;
      font-family: Calibri;
      font-weight: 400;
      font-size: 1.50rem;
      color: #FEFEFE;
      margin-right: 3.68rem;
    }
  }
  .login_right {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    padding-left: 3.75rem;
    width: 41.17rem;
    &.elinker {
      .imgLogo_box {
        margin-top: 5rem;
        height: 5.6rem;
        line-height: 5.6rem;
      }
      .p2 {
        margin-top: 2.9rem;
      }
    }
    &.room {
      .imgLogo_box {
        margin-top: 5rem;
        height: 5.6rem;
        line-height: 5.6rem;
      }
      .p2 {
        margin-top: 2.9rem;
      }
    }
    .imgLogo_box {
      height: 1.6rem;
      line-height: 1.6rem;
      margin-top: 7rem;
      img {
        height: 100%;
        // height: 100%;
      }
    }
    .p2 {
      margin-top: 4.9rem;
      font-family: AlibabaPuHuiTiM;
      font-size: 5rem;
      color: #fff;
      letter-spacing: 0;
    }
    .p3 {
      font-family: AlibabaPuHuiTiM;
      font-size: 1.83rem;
      color: #657085;
      letter-spacing: 0;
    }
    .el-input {
      width: 31.67rem;
      .el-input__inner {
        height: 3.33rem;
        line-height: 3.33rem;
        background: #f6f8fa;
        border-radius: 2px;
        border-radius: 2px;
      }
      img {
        margin: 1rem 0 0 0.3rem;
        height: 1rem;
      }
    }
    .input1 {
      margin: 6rem 0 0 1rem;
    }
    .input2 {
      margin: 1.67rem 0 0 1rem;
      .el-input__icon {
        line-height: 3.33rem;
      }
    }
    .input3_box {
      margin: 1.67rem 0 0 1rem;
      display: flex;
      .input3 {
        width: 20.5rem;
      }
      .img_box {
        background: #f2f2f2;
        // border: 1px solid #DDDDDD;
        border-radius: 2px;
        overflow: hidden;
        margin-left: 0.83rem;
        width: 10.33rem;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .btn_box {
      margin: 2.5rem 0 0.83rem 1rem;
      width: 31.67rem;
      height: 3.33rem;
      line-height: 3.33rem;
      text-align: center;
      background: #05cfab;
      border: 1px solid #05cfab;
      border-radius: 2px;
      cursor: pointer;
      span {
        font-family: PingFang-SC-Medium;
        font-size: 1.17rem;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
      }
    }
    .flex_box {
      margin-left: 1rem;
      width: 31.67rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-checkbox {
        color: #fff;
        
      }
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #fff;
        
      }
      .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #05cfab;
        border-color: #05cfab;
      }
      .btn_span {
        font-family: PingFang-SC-Medium;
        font-size: 1rem;
        color: #fff;
        letter-spacing: 0;
        text-align: right;
        line-height: 1.42rem;
        cursor: pointer;
      }
    }
    .login_box {
      position: absolute;
      left: 0;
      bottom: 1.08rem;
      width: 100%;
      // text-align: center;
      // img{
      //   width: 10rem;height: 2.42rem;
      // }
      .box1 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 4.75rem;
        padding-bottom: 0.2rem;
        border-bottom: 0.1rem solid #ffffff;
        img {
          width: 11rem;
        }
        a {
          // font-family: AlibabaPuHuiTiR;
        font-family: Calibri;

          font-size: 1rem;
          color: #ffffff;
          font-weight: 500;
        }
      }
      .p4 {
        // font-family: AlibabaPuHuiTiR;
        font-family: Calibri;

        font-size: 1rem;
        color: #ffffff;
        margin: 0 4.75rem;
        // letter-spacing: 0;
        span {
          display: inline-block;
          height: 2rem;
          position: relative;
          top: 0.8rem;
          left: -0.5rem;
          cursor: pointer;
          // color: #17598a;
          // font-size: 1.2rem;
          // font-weight:500;
          img {
            height: 100%;
          }
        }
      }
    }
  }

  .boot{
    opacity: 0.9;
    margin-top: 9rem;
    .el-dialog__body {
      text-align: center;
      .text {
        font-family: Calibri;
        font-weight: normal;
        font-size: 1.64rem;
        color: #4C717C;
      }
    }
    .el-dialog__footer {
      text-align: center;
      .el-button{
        width: 6.25rem;
        height: 2.63rem;
        line-height: 2.63rem;
        padding: 0;

        font-family: Calibri;
        font-weight: normal;
        font-size: 1.64rem;
        color: #4C717C;
        line-height: 0.8rem;
      }
    }
  }

  .password_dialog{
    .p_top{
      margin-bottom: 20px;
      >p{
        // float: left;
        width: 300px;
        border-bottom: 2px solid #E4E7ED;
        .el-button{
          position: relative;
          top: 2px;
          color:rgba(68,68,68,1);
          padding: 12px 0px;
          cursor: inherit;
        }
        >span{
          position: relative;
          top: 2px;
          padding:0 16px;
          color:#888888;
        }
        .select{
          border-bottom: 2px solid #1989FA;
          border-radius: 0px;
        }
      }
      .el-select{
        float: right;
        margin-top: 5px;
      }
      >.w_315{
        width: 315px;
      }
    }
    .el-form{
      width: 80%;
      // .el-form-item {
      //   .el-input {
      //     display: inline-block;
      //     width: 100%;
      //   }
      // }
    }
    .getVerificatioCode .el-form-item__content{
      display: flex;
      .input_button{
        flex:1;
      }
    }
    .el-dialog__body{
        padding: 20px 20px 0px;
    }
    .el-dialog__header{
      padding: 0 20px 0 30px;
      height: 50px;
      line-height: 50px;
      border: 1px solid #e8e8e8;
    }
    .input_button{
        width: calc(60% - 107px);
    }
  }
}
</style>
